export const GET_MONTHLY_AUDIT_SUMMARY = 'GET_MONTHLY_AUDIT_SUMMARY'
export const CREATE_MONTHLY_AUDIT_SUMMARY = 'CREATE_MONTHLY_AUDIT_SUMMARY'
export const DELETE_ALL_MONTHLY_AUDIT_SUMMARY = 'DELETE_ALL_MONTHLY_AUDIT_SUMMARY'
